export default __webpack_public_path__ + "static/media/waqar.5a39e381.svg";